import storage from 'redux-persist/lib/storage';
import { createTransform, persistReducer } from 'redux-persist';

/** portalBootReady é só da sessão atual — não persistir (VLibras após APIs). */
const configurationBootTransform = createTransform(
  inboundState => {
    if (!inboundState || typeof inboundState !== 'object') {
      return inboundState;
    }
    const { portalBootReady, ...rest } = inboundState;
    return rest;
  },
  outboundState => ({
    ...outboundState,
    portalBootReady: false,
  }),
  { whitelist: ['configuration'] }
);

function persist(reducers) {
  const persistedReducers = persistReducer(
    {
      key: 'smarapd-pai-portal',
      storage,
      whitelist: ['configuration'],
      transforms: [configurationBootTransform],
    },
    reducers
  );

  return persistedReducers;
}

export default persist;
